export Dialog from './Dialog'
export DialogBody from './DialogBody'
export DialogButton from './DialogButton'
export DialogFooter from './DialogFooter'
export DialogHeader from './DialogHeader'

export default from './Dialog'



// WEBPACK FOOTER //
// ./src/Dialog/index.js